import { useSearchParams } from 'react-router-dom';
import { PinComment } from '../PinComment/PinComment';

/**
 * Hook to manage the query params for pinned comments on a revision request
 */
export function useRevisionRequestQueryParams(pin: PinComment): {
    commentId: string | null | undefined;
    pinClickHandler: () => void;
    closeHandler: (id?: string) => void;
} {
    const isDevEnv =
        window.location.hostname === 'localhost' ||
        window.location.hostname.includes('staging.vistaprint.com');
    const [searchParams, setSearchParams] = useSearchParams();
    const commentId = searchParams.has('commentId') ? searchParams.get('commentId') : null;
    const closeHandler = (id?: string) => {
        // don't close the popover if another pin has been clicked
        if (id && id !== commentId) {
            return;
        }
        setSearchParams({
            selectedSurface: String(pin.selectedSurface),
            deliveryVariationId: String(pin.deliveryVariationId),
            ...(isDevEnv && { activePanel: 'designs' }), // TODO: Remove isDevEnv check when shipping revision drawer to production. Once we introduce the revision request drawer, the Submit button (for revision request) will be in the same view as the canvas, so we won't need to switch back to the revision request panel. This makes no difference on desktop.
        });
    };

    const pinClickHandler = () => {
        setSearchParams({
            selectedSurface: String(pin.selectedSurface),
            deliveryVariationId: String(pin.deliveryVariationId),
            commentId: String(pin.commentId),
            ...(isDevEnv && { activePanel: 'designs' }), // TODO: Remove isDevEnv check when shipping revision drawer to production.
        });
    };

    return {
        commentId,
        closeHandler,
        pinClickHandler,
    };
}
